import React, { useEffect, useState } from "react";
import Footer from "../../../Components/Footer/footer";
import SimpleButton from "../../../Components/layouts/simple_button";
import StepRoutes from "../../../Routes/steps_routes";
import { NavLink, useParams } from "react-router-dom";
import LoadingPage from "../../../Components/layouts/loading";
import { Toast } from "../../../CustomComponent/toast";
import performRequest from "../../../api/request";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import { FcFlowChart } from "react-icons/fc";

const ViewFeature = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState();
  let { id } = useParams();

  useEffect(() => {
    setLoading(true);
    performRequest("GET", `/features/getFeaturesById/${id}`)
      .then((res) => {
        if (res.status === 200) {
          setData(res.data);
        } else {
          Toast("error", "Error while getting PO!");
        }
        setLoading(false);
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, [id]);

  if (loading) {
    return <LoadingPage />;
  }
  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xl">
          <div className="page-header d-print-none">
            <div className="row g-2 align-items-center">
              <div className="col">
                <h2 className="page-title mb-1">
                  <FcFlowChart className="fs-2 me-1" />
                  Feature Docs
                </h2>
                <h4 className="text-muted">
                  <StepRoutes />
                </h4>
              </div>
            </div>
          </div>
          <div className="card my-4">
            <div className="card-header">
              <h2 className="page-title">View Feature</h2>
            </div>
            <div className="card-body">
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">Feature</label>
                  <div className="col">
                    {(data?.feature || "N/A").toUpperCase()}
                  </div>
                </div>
              )}

              {data && (
                <div className="mb-3 row">
                  <label className="col-3 form-label">Description</label>
                  <div className="col">
                    {(data?.description || "N/A").toUpperCase()}
                  </div>
                </div>
              )}

              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">Access Roles</label>
                  <div className="w-100 col">
                    {data?.accessRoles?.join(", ").toUpperCase() || "N/A"}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="col-3 form-label">Status</label>
                  <div className="col">
                    {(data?.status || "N/A").toUpperCase()}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="col-3 form-label">Conditions</label>
                  <div className="col">
                    {(data?.conditions || "N/A").toUpperCase()}
                  </div>
                </div>
              )}

              {data && (
                <div className="mb-3 row">
                  <label className="col-3 form-label">Access route</label>
                  <div className="col">
                    {data?.accessRoute ? (
                      <NavLink to={data?.accessRoute}>
                        {data?.accessRoute.toUpperCase()}
                      </NavLink>
                    ) : (
                      "N/A"
                    )}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="col-3 form-label">Design by</label>
                  <div className="col">
                    {(data?.designBy || "N/A").toUpperCase()}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="col-3 form-label">Develope by</label>
                  <div className="col">
                    {(data?.developBy || "N/A").toUpperCase()}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="col-3 form-label">Backend by</label>
                  <div className="col">
                    {(data?.backendBy || "N/A").toUpperCase()}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="col-3 form-label">Aditional Notes</label>
                  <div className="col">
                    {(data?.notes || "N/A").toUpperCase()}
                  </div>
                </div>
              )}
              <hr />
              <h3>Newly Updates</h3>
              <hr />
              {data?.newlyUpdates?.length > 0 &&
                data?.newlyUpdates.map((update, index) => (
                  <div key={index} className="mb-2 row g-3 align-items-center">
                    <div className="mb-3 row">
                      <label className="col-3 form-label">
                        Feature updates
                      </label>
                      <div className="col">
                        {(update?.update || "N/A").toUpperCase()}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="col-3 form-label">Updated By</label>
                      <div className="col">
                        {(update?.updatedBy || "N/A").toUpperCase()}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="col-3 form-label">Updated On</label>
                      <div className="col">
                        {(update?.updatedAt || "N/A").toUpperCase()}
                      </div>
                    </div>

                    <hr className="mt-2" />
                  </div>
                ))}
              <hr />
              <h3>Sub Features</h3>
              <hr />

              {data?.subFeature?.map((update, index) => (
                <div key={index} className="mb-2 align-items-center">
                  <div className="mb-2 row g-3 align-items-center">
                    <div className="mb-3 row">
                      <label className="col-3 form-label">Feature</label>
                      <div className="col">
                        {(update?.feature || "N/A").toUpperCase()}
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="col-3 form-label">Description</label>
                      <div className="col">
                        {(update?.description || "N/A").toUpperCase()}
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="col-3 form-label">Created by</label>
                      <div className="col">
                        {(update?.createdBy || "N/A").toUpperCase()}
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="col-3 form-label">Created On</label>
                      <div className="col">
                        {(update?.date || "N/A").toUpperCase()}
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="col-3 form-label">Access Route</label>
                      <div className="col">
                        {update?.accessRoute ? (
                          <NavLink to={update?.accessRoute}>
                            {update?.accessRoute.toUpperCase()}
                          </NavLink>
                        ) : (
                          "N/A"
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="mb-3 row">
                    <label className="col-3 form-label">Access roles</label>
                    <div className="col">
                      {(update?.accessRoles?.join(", ") || "N/A").toUpperCase()}
                    </div>
                  </div>
                  <hr className="mt-2" />
                </div>
              ))}
            </div>
            <div className="card-footer">
              <div className="btn-list justify-content-end">
                <SimpleButton
                  buttonText="Edit feature"
                  href={`/feature-docs/edit/${id}`}
                />
                <SimpleButton buttonText="Cancel" type="secondary" />
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    </div>
  );
};

export default ViewFeature;
